module.exports = __webpack_public_path__ + "img/MemeETC (10).6cfaaf1f.jpeg";